import { NavIcon } from './NavIcon';
import { MOBILE_TAB_IDS, NAV_ITEMS, PROFILE_ITEM } from './navigation';
import type { ScreenId } from './navigation';

interface MoreSheetProps {
  onNavigate: (screen: ScreenId) => void;
  onClose: () => void;
  onSignOut?: () => void;
}

/** Bottom sheet do celular com as telas que não couberam nas tabs. */
export function MoreSheet({ onNavigate, onClose, onSignOut }: MoreSheetProps) {
  const items = [
    ...NAV_ITEMS.filter((item) => !MOBILE_TAB_IDS.includes(item.id)),
    PROFILE_ITEM,
  ];

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-[rgb(10_20_45/0.45)]"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="animate-rise fixed inset-x-0 bottom-0 z-50 rounded-t-[20px] bg-white p-3.5 pb-[calc(18px+env(safe-area-inset-bottom))]">
        <div className="bg-line-300 mx-auto mb-3 h-1 w-[38px] rounded-full" />

        <div className="grid grid-cols-[repeat(auto-fit,minmax(140px,1fr))] gap-2">
          {items.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => onNavigate(item.id)}
              className="border-surface-300 bg-surface-100 text-ink-900 hover:border-navy-800 flex min-h-12 items-center gap-2.5 rounded-xl border px-3.5 py-3 text-left text-[13px] font-bold"
            >
              <NavIcon path={item.icon} size={18} className="text-navy-800" />
              <span className="flex-1">{item.label}</span>
            </button>
          ))}
        </div>

        {onSignOut ? (
          <button
            type="button"
            onClick={onSignOut}
            className="border-danger-200 text-danger-600 mt-2 w-full rounded-xl border bg-white p-3 text-[14px] font-extrabold"
          >
            Sair da conta
          </button>
        ) : null}
      </div>
    </>
  );
}
